export default __webpack_public_path__ + "static/media/h01.2fb9d6ab.svg";